// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","388":"2c386607","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"11414b7e9014301016f4","245":"0f599a0109ba14864ff6","388":"36cadebfe110a02a933f","452":"84a2c14cb713c1104bf3","453":"abba976ea630a6cbcdcc"}[chunkId] + ".js";
};